import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
interface MainColorTabsWrapperProps {
    mainColor: string;
}

const BorderWrapper = styled.div<MainColorTabsWrapperProps>`
    .nav-item-active__clz .active-tab__clz {
        border-bottom: 3px solid ${(props) => props.mainColor} !important;
    }
`;

export function MainColorTabsWrapper({
    children,
}: {
    children: React.ReactNode;
}): JSX.Element {
    const mainColor = useSelector(
        (state: any) => state.global.infoUser.maincolor
    );

    return <BorderWrapper mainColor={mainColor}>{children}</BorderWrapper>;
}
